<template>
  <div class="home-container">
    sellOrder<br>
    <button @click="mintNft">
      铸造nft
    </button> <br>
    <button @click="getNftList">
      获取我的nft
    </button><br><br><br>
    我的nft列表
    <ul>
      <li v-for="item in list" :key="item.tokenID">
        <input v-model="selectNft" type="checkbox" :value="item" name="vehicle" @change="Nftchenge"> {{ item.tokenID }}
      </li>
    </ul><br><br>
    <button @click="checkapprove">
      检查是否授权
    </button>
    <br><br>
    
    <ul>
      <li v-for="item in selectNft" :key="item.tokenID">
        <!-- {{ item }} -->
        <button v-if="item.approveAllstates==false" :disabled="item.approveAllstates" @click="approve(item)">
          nft授权 {{ item.tokenID }}  
        </button>
        <div>
          nft{{ item.tokenID }} 价格 
          <input v-model="message" placeholder="edit me" readonly>
          <br>
        </div>
      </li>
    </ul>
    <br>
    单位：
    <input type="radio" name="cointype" value="eth" @change="setcointype('eth')">eth
    <input type="radio" name="cointype" value="weth" @change="setcointype('weth')">weth
    <br><br>
    <button @click="sellOrder">
      卖出
    </button>
    <br><br>
    针对上面卖出的订单操作
    <br><br>
    <button @click="buyOrder">
      买入
    </button>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import {mintMyNFT,getmynftList,checkapproveAll,approveAll,
getsellToken,wapOrderdetails} from '@/contactLogic/swap/index.js';

import {AddDayTimes,AddmintTimes}  from '@/contactLogic/swap/utils.js';


let offChainOrder;
export default {
  data() {
    return {
    list:[], 
    selectNft:[],
    selectNftPrise:[],
    message:'1', 
    cointype:'eth'
    };
  },
  methods: {
    setcointype(cointype){
      this.$data.cointype=cointype;

    },
    mintNft(){
      const library= this.ethersprovider;
      const account = this.ethAddress;
      const chainID =this.ethChainID;
      const tokenID=2;
      mintMyNFT(library, account, chainID,tokenID);
    },
   async getNftList(){
     const library= this.ethersprovider;
      const account = this.ethAddress;
      const chainID =this.ethChainID;

     this.$data.list = await getmynftList(library, account, chainID);
     console.log(this.$data.list);

    },
    async checkapprove(){
      const library= this.ethersprovider;
      const account = this.ethAddress;
      const chainID =this.ethChainID;

      const list = this.$data.selectNft;
      this.$data.selectNft=[];
      console.log('select ',list);
      for (let index = 0; index < list.length; index++) {
        const element = list[index];
        const result  = await checkapproveAll(library, account, chainID,element.tokenAddress);
        element.approveAllstates=result;
        
      }
      console.log(this.$data.selectNft);
      this.$data.selectNft=list;
     
     

    },
    async approve(element){
      const library= this.ethersprovider;
      const account = this.ethAddress;
      const chainID =this.ethChainID;

      const result  = await approveAll(library, account, chainID,element.tokenAddress);


    },
    Nftchenge(){
      console.log(this.$data.selectNft);
      

    },
   async sellOrder(){
      const library= this.ethersprovider;
      const account = this.ethAddress;
      const chainID =this.ethChainID;
      const expireTime = AddmintTimes(2);
      const web3 = this.web3;
      const Price = "1";
      const unit=this.$data.cointype;

    //  offChainOrder = await sellOrder(library, account, chainID,tokenId,Price,expireTime,web3);
    //  console.log(offChainOrder);
    const sellTokenCon = new  getsellToken();
    console.log("sellTokenCon",sellTokenCon);
    console.log("sellTokenCon.addnft",sellTokenCon.addnft);
    this.$data.selectNft.forEach(element => {
      const Nftcontractaddress =element.tokenAddress;
      const tokenId = element.tokenID;
      sellTokenCon.addnft(Nftcontractaddress,tokenId,Price);    
    });

    const result = await sellTokenCon.sellOrder(library, account, chainID,expireTime,unit);
    console.log('offChainOrder',result);
    offChainOrder = result;
    const ordertoserver = sellTokenCon.getorderForServer();
    console.log('ordertoserver',ordertoserver);
    console.log('ordertoserver',JSON.stringify(ordertoserver) );

    const data1 = await sellTokenCon.sendOrderToserver();
    console.log('server',data1);

    
    },
    async buyOrder(){
      const library= this.ethersprovider;
      const account = this.ethAddress;
      const chainID =this.ethChainID;
      const Price = "1";
      const tokenId = this.$data.selectNft[0];
      const expireTime = AddDayTimes(2);
      const web3 = this.web3;

      const wapOrder = new wapOrderdetails(chainID);
      const tokenIndexOfChainOrder =0;
      wapOrder.addBuyorder(offChainOrder,tokenIndexOfChainOrder);

      const result = await wapOrder.executeOrder(library, account, chainID,expireTime);
      console.log(result);

      // const data = await buyOrder(library, account, chainID,offChainOrder,expireTime);

    }

    
  },
  mounted() {

    
  },
    computed: {
        ...mapState(['web3', 'ethersprovider', 'ethChainID', 'ethAddress']),
        isReady() {
            return this.web3 && this.ethersprovider && this.ethChainID && this.ethAddress;
        }
        
    },
};
</script>
<style lang="less" scoped>
input{
      color: black;
}
</style>
